import React, { useState } from 'react';

function LoginPage({ onPasswordLogin, onCodeLogin, onRequestCode, busyExternal }) {
  const [useCodeLogin, setUseCodeLogin] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [requestingCode, setRequestingCode] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const disabled = submitting || busyExternal;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setSubmitting(true);

    try {
      if (useCodeLogin) {
        await onCodeLogin(email, code);
      } else {
        await onPasswordLogin(email, password);
      }
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  const handleRequestCode = async () => {
    setError('');
    setMessage('');
    setRequestingCode(true);

    try {
      await onRequestCode(email);
      setMessage('Login code sent to your email.');
    } catch (err) {
      setError(err.message || 'Unable to send code');
    } finally {
      setRequestingCode(false);
    }
  };

  return (
    <main className="page-shell auth-shell">
      <section className="auth-card">
        <span className="eyebrow">Web access</span>
        <h1>Log in to Talkali</h1>
        <p className="auth-subtitle">
          Continue with email and password or switch to email code login.
        </p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="field-label">
            <span>Email</span>
            <input
              className="text-input"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
            />
          </label>

          {useCodeLogin ? (
            <>
              <label className="field-label">
                <span>Email code</span>
                <input
                  className="text-input"
                  type="text"
                  value={code}
                  onChange={(event) => setCode(event.target.value)}
                  placeholder="Enter your code"
                />
              </label>

              <button
                className="secondary-button full-width"
                type="button"
                onClick={handleRequestCode}
                disabled={requestingCode || disabled}
              >
                {requestingCode ? 'Sending code...' : 'Send code'}
              </button>
            </>
          ) : (
            <label className="field-label">
              <span>Password</span>
              <input
                className="text-input"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Your password"
                autoComplete="current-password"
              />
            </label>
          )}

          {error ? <div className="notice error-notice">{error}</div> : null}
          {message ? <div className="notice success-notice">{message}</div> : null}

          <button className="primary-button full-width" type="submit" disabled={disabled}>
            {submitting ? 'Signing in...' : useCodeLogin ? 'Log in with code' : 'Log in'}
          </button>
        </form>

        <div className="auth-switch-row">
          <button
            className="nav-link"
            onClick={() => {
              setUseCodeLogin((current) => !current);
              setError('');
              setMessage('');
            }}
          >
            {useCodeLogin ? 'Use password instead' : 'Login via email code'}
          </button>
        </div>

        <div className="auth-divider" />

        <div className="auth-footer-cta">
          <span>Need an account?</span>
          <a className="nav-link" href="/#apps-section">
            Create account
          </a>
        </div>
      </section>
    </main>
  );
}

export default LoginPage;